import { render, staticRenderFns } from "./Huay.vue?vue&type=template&id=443f70bc&scoped=true&"
import script from "./Huay.vue?vue&type=script&lang=js&"
export * from "./Huay.vue?vue&type=script&lang=js&"
import style0 from "./Huay.vue?vue&type=style&index=0&id=443f70bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f70bc",
  null
  
)

export default component.exports